export const convertToTitleCase = (inputString: string) => {
  let lowerCaseString = inputString?.toLowerCase() || '';
  let convertedString = lowerCaseString.replace(/([a-z])([A-Z])/g, '$1 $2');
  convertedString = convertedString.replace(/_/g, ' ');
  convertedString = convertedString.replace(/\b\w/g, firstLetter => firstLetter?.toUpperCase());
  return convertedString;
};

export function formatDate(dateString: string | number | Date) {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }
  return date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export const darkenHexColor = (hex, percent) => {
  if (!/^#([0-9A-F]{6})$/i.test(hex)) return hex; // Validate hex format

  let num = parseInt(hex.slice(1), 16);
  let amt = Math.round(2.55 * percent * 1.5); // Stronger darkening effect

  let r = Math.max(0, (num >> 16) - amt);
  let g = Math.max(0, ((num >> 8) & 0x00ff) - amt);
  let b = Math.max(0, (num & 0x0000ff) - amt);

  let darkerHex = `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;

  return darkerHex;
};



